<template>
    <div class="web-apply">
        <div class="content-header">
             <img src="../assets/logo1.png" style='width:60px;height:60px;vertical-align: middle;margin-right: 20px;' alt="">内蒙古综检联网平台 (检测站申请接入入口)
        </div>
        <el-row class="form-container" :gutter="20" style="margin:50px auto">
            <el-col :span="12">
                <div class="grid-content bg-purple">
                    <el-form ref="form" :model="model" label-width="180px">
                        <el-form-item label="机构名称">
                            <el-input v-model="model.merchantName" placeholder="请输入机构名称"></el-input>
                        </el-form-item>
                        <el-form-item label="所在蒙市">
                            <el-select v-model="model.cityName" placeholder="请选择所在蒙市">
                                <el-option
                                    v-for="item in cityNameList"
                                    :key="item.text"
                                    :label="item.text"
                                    :value="item.text">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="经营地址">
                            <el-input v-model="model.merchantAddress" placeholder="请选择经营地址"></el-input>
                        </el-form-item>
                        <el-form-item label="成立日期">
                            <el-date-picker
                                v-model="model.createStationDate"
                                type="date"
                                placeholder="请选择成立日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="企业性质">
                            <el-select v-model="model.dsType" placeholder="请选择企业性质">
                                <el-option
                                    v-for="item in dsTypeList"
                                    :key="item.value"
                                    :label="item.text"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="统一社会信息代码">
                            <span @click="showTips(1)" class="input-tips">查看示例</span>
                            <el-input v-model="model.orgNumber">
                                
                            </el-input>
                        </el-form-item>
                        <el-form-item label="企业邮箱">
                            <el-input v-model="model.email" placeholder="请输入企业邮箱"></el-input>
                        </el-form-item>
                        <el-form-item label="标定/标准证书编号">
                            <span @click="showTips(2)" class="input-tips">查看示例</span>
                            <el-input v-model="model.ma" placeholder="请输入标定/标准证书编号"></el-input>
                        </el-form-item>
                        <el-form-item label="标定/标准证书到期日期">
                            <span @click="showTips(3)" class="input-tips">查看示例</span>
                            <el-input v-model="model.maExpDate" placeholder="请输入标定/标准证书到期日期"></el-input>
                        </el-form-item>
                        <el-form-item label="人员数量">
                            <el-input v-model="model.staffNumber" placeholder="请输入人员数量" type='number'></el-input>
                        </el-form-item>      
                    </el-form>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="grid-content bg-purple">
                   <el-form ref="form" :model="model" label-width="180px">
                       <el-form-item label="机构年检测能力">
                            <el-input v-model="model.detectCapYear" placeholder="请输入机构年检测能力" type='number'></el-input>
                        </el-form-item>
                        <el-form-item label="机构月检测能力">
                            <el-input v-model="model.detectCapMonth" placeholder="请输入机构月检测能力" type='number'></el-input>
                        </el-form-item>  
                        <el-form-item label="机构日检测能力">
                            <el-input v-model="model.detectCapDay" placeholder="请输入机构年日测能力" type='number'></el-input>
                        </el-form-item>    
                        <el-form-item label="负责人">
                            <el-input v-model="model.contactName" placeholder="请输入负责人姓名"></el-input>
                        </el-form-item>  
                        <el-form-item label="负责人电话">
                            <el-input v-model="model.contactPhone" placeholder="请输入负责人电话"></el-input>
                        </el-form-item>  
                        <el-form-item label="操作员">
                            <el-input v-model="model.operator" placeholder="请输入操作员姓名"></el-input>
                        </el-form-item>  
                        <el-form-item label="操作员联系电话">
                            <el-input v-model="model.operatorPhone" placeholder="请输入操作员联系电话"></el-input>
                        </el-form-item>  
                        <el-form-item label="财务">
                            <el-input v-model="model.accountant" placeholder="请输入财务人员姓名"></el-input>
                        </el-form-item>  
                        <el-form-item label="财务联系电话">
                            <el-input v-model="model.accountantPhone" placeholder="请输入财务人员联系电话"></el-input>
                        </el-form-item>  
                        <el-form-item label="技术员">
                            <el-input v-model="model.technician" placeholder="请输入技术员姓名"></el-input>
                        </el-form-item>  
                        <el-form-item label="技术员联系电话">
                            <el-input v-model="model.technicianPhone" placeholder="请输入技术员联系电话"></el-input>
                        </el-form-item>  

                   </el-form>
                </div>
            </el-col>
            <el-button class="apply" type='primary' @click="apply">提交申请</el-button>
        </el-row>
        <el-dialog  width='32%' :visible.sync="showImgTips" style="text-align:center;">
            <img :src="imgTipsScr" alt="">
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import {merchant} from '../modules/axios/request'
    export default {
        data() {
            return {
                model: {
                    orgId:'100',
                    merchantName: '',
                    createStationDate: '',
                    merchantAddress: '',
                    dsType: '',
                    dsTypeName: '',
                    cityName: '',
                    ma: '',
                    maExpDate: '',
                    email: '',
                    orgNumber: '',
                    staffNumber: '',
                    detectCapYear: '',
                    detectCapMonth: '',
                    detectCapDay: '',
                    contactName: '',
                    contactPhone: '',
                    operator: '',
                    operatorPhone: '',
                    accountant: '',
                    accountantPhone: '',
                    technician: '',
                    technicianPhone: '',
                    applicant:  ''
                },
                dsTypeList : [
                    {value:"100",text: "内资"},
                    {value:"110",text: "国有全资"},
                    {value:"120",text: "集体全资"},
                    {value:"130",text: "股份合作"},
                    {value:"140",text: "联 营"},
                    {value:"141",text: "国有联营"},
                    {value:"142",text: "集体联营"},
                    {value:"143",text: "国有与集体联营"},
                    {value:"149",text: "其他联营"},
                    {value:"150",text: "有限责任(公司)"},
                    {value:"159",text: "其他有限责任(公司)"},
                    {value:"160",text: "股份有限(公司)"},
                    {value:"170",text: "私有"},
                    {value:"171",text: "私有独资"},
                    {value:"172",text: "私有合伙"},
                    {value:"173",text: "私营有限责任(公司)"},
                    {value:"174",text: "私营股份有限(公司)"},
                    {value:"175",text: "个体经营"},
                    {value:"179",text: "其他私有"},
                    {value:"190",text: "其他内资"},
                    {value:"900",text: "其 他"}
                ],
                cityNameList : [
                    {text: "阿拉善盟"},
                    {text: "兴安盟"},
                    {text: "乌兰察布市"},
                    {text: "巴彦淖尔市"},
                    {text: "呼伦贝尔市"},
                    {text: "鄂尔多斯市"},
                    {text: "通辽市"},
                    {text: "赤峰市"},
                    {text: "乌海市"},
                    {text: "包头市"},
                    {text: "呼和浩特市"},
                    {text: "锡林浩特市"},
                    {text: "满州里市"},
                    {text: "二连浩特市"},
                    {text: "锡林郭勒盟"}
                ],
                showImgTips:false,
                imgTipsScr:''
            }
        },
        methods: {
            showTips(num) {
                this.showImgTips=true
                if(num==2){
                    this.imgTipsScr=require('../assets/example'+num+'.jpg')
                }else{
                    this.imgTipsScr=require('../assets/example'+num+'.png')
                }
            },
            apply(){
                var  emailReg=/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
                var  phoneReg=/^1(0|1|2|3|4|5|6|7|8|9)\d{9}$/
                if(this.model.email&&!emailReg.test(this.model.email)){
                    this.$message.error('请填写正确的邮箱格式');
                    return
                }
                if(!this.model.merchantName){
                    this.$message.error('请填写机构名称');
                    return
                }
                if(!this.model.cityName){
                    this.$message.error('请选择所在蒙市');
                    return
                }
                if(!this.model.merchantAddress){
                    this.$message.error('请填写经营地址');
                    return
                }
                if(!this.model.createStationDate){
                    this.$message.error('请选择成立日期');
                    return
                }
                if(!this.model.dsType){
                    this.$message.error('请填写企业性质');
                    return
                }
                if(!this.model.orgNumber){
                    this.$message.error('请填写社会信息代码');
                    return
                }
                if(!this.model.contactName){
                    this.$message.error('请填写负责人名字');
                    return
                }
                if(!this.model.contactPhone||!phoneReg.test(this.model.contactPhone)){
                    this.$message.error('请填写正确的负责人联系电话');
                    return
                }
                if(this.model.operatorPhone&&!phoneReg.test(this.model.operatorPhone)){
                    this.$message.error('请填写正确的操作员电话');
                    return
                }
                if(this.model.operatorPhone&&!phoneReg.test(this.model.operatorPhone)){
                    this.$message.error('请填写正确的操作员电话');
                    return
                }
                if(this.model.accountantPhone&&!phoneReg.test(this.model.accountantPhone)){
                    this.$message.error('请填写正确的财务员电话');
                    return
                }
                if(this.model.technicianPhone&&!phoneReg.test(this.model.technicianPhone)){
                    this.$message.error('请填写正确的技术员电话');
                    return
                }
                
                axios.post(merchant.addMerchant,this.model)
                .then(({body})=>{
                    if(body){
                        console.log(body)
                    }
                })
            }
        },
        
    }
</script>

<style scoped lang='stylus'>
.web-apply{
    .content-header{
        margin:20px 0 20px 5px;
        font-size 24px
        color: #317eac;
        border-bottom:1px solid #ccc
        padding-bottom:20px
        text-align center
        height 60px
        line-height 60px
    }
    .form-container{
        width 70%
        margin 20px auto
        text-align center
    }
    .apply{
        margin-top:50px
    }
    .input-tips{
        position: absolute;
        top: 0px;
        z-index: 1;
        color orange
        right: 20px
        cursor pointer
    }
    .el-dialog img{
        width:100%
    }
}

</style>
<style>
.web-apply .el-form-item__label{
    font-weight: bold
}
.web-apply .el-form-item__content{
    text-align: left;
    position: relative
}
.web-apply .el-dialog{
    margin-top: 10px !important
}

    
</style>